import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import {
  EQUIPMENT,
  FINE_ART,
  SCHEDULE_ROOT,
  SUBSCRIPTION,
  TOOL_FLOATER,
  UNDERLYING,
} from "./Business.constants";

const ScheduleRoot = Loadable(
  lazy(() =>
    import("./ScheduleRoot").then(({ ScheduleRoot }) => ({
      default: ScheduleRoot,
    }))
  )
);
const FineArt = Loadable(
  lazy(() =>
    import("./FineArt/FineArtPage").then(({ FineArtPage }) => ({
      default: FineArtPage,
    }))
  )
);
const ToolFloater = Loadable(
  lazy(() =>
    import("./ToolFloater/ToolFloaterPage").then(({ ToolFloaterPage }) => ({
      default: ToolFloaterPage,
    }))
  )
);
const Equipment = Loadable(
  lazy(() =>
    import("./Equipment/EquipmentPage").then(({ EquipmentPage }) => ({
      default: EquipmentPage,
    }))
  )
);
const UnderLying = Loadable(
  lazy(() =>
    import("./UnderLying/UnderLying").then(({ UnderLying }) => ({
      default: UnderLying,
    }))
  )
);
const Subscription = Loadable(
  lazy(() =>
    import("./Subscription/Subscription").then(({ Subscription }) => ({
      default: Subscription,
    }))
  )
);

export const ScheduleRoutes = [
  {
    path: `${SCHEDULE_ROOT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ScheduleRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${FINE_ART}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <FineArt />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${FINE_ART}/:fineArtNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <FineArt />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${TOOL_FLOATER}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ToolFloater />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${TOOL_FLOATER}/:toolFloaterNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <ToolFloater />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${EQUIPMENT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Equipment />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${EQUIPMENT}/:equipmentNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Equipment />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${UNDERLYING}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <UnderLying />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${UNDERLYING}/:underlyingNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <UnderLying />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${SUBSCRIPTION}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Subscription />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${SUBSCRIPTION}/:subscriptionNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Subscription />
      </AuthorizedRoute>
    ),
  },
];
